module.exports = __webpack_public_path__ + "img/hands.ff1348c8.svg";